import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import * as firebase from "firebase";
import { AngularFirestore } from "@angular/fire/firestore";
import { Observable, Subscription } from "rxjs";
import { CityApi } from "../api/city.api";
import { City, Venue } from "../models";

@Injectable({
  providedIn: "root"
})
export class CityService {
  public api: CityApi;
  public cities$: Observable<City[]>;
  public cities: City[];
  public total_active_venues: number;
  public placeholders: number;
  public cache: {};
  public current: City;
  public venues$: Observable<Venue[]>; //Selected Cities Venue Observable
  public venues: Venue[];

  public cSubscription: Subscription;
  public vSubscription: Subscription;
  constructor(public db: AngularFirestore, private httpClient: HttpClient) {
    this.api = new CityApi(db, this.httpClient);
    this.cache = {};
    this.initObserver();
    this.initSubscription();
  }

  public initCity = (): City => this.api.new();

  public select(city: City) {
    this.current = city;
    this.venues = [];
    this.venues$ = this.api.getVenuesForCity(city);
    if (this.vSubscription != null) this.vSubscription.unsubscribe();
    this.vSubscription = this.venues$.subscribe(async venues => {
      if (this.venues != [])
        for (var i = 0; i < this.venues.length; i++)
          this.cache[this.venues[i].name] = this.venues[i].passes;

      this.venues = venues.sort((a, b) => {
        if (a.is_active && !b.is_active) return -1;
        if (!a.is_active && b.is_active) return 1;
        return a.rank - b.rank;
      });
      for (var i = 0; i < this.venues.length; i++) {
        let name = this.venues[i].name;
        let isCached = Object.keys(this.cache).includes(name);
        isCached
          ? (this.venues[i].passes = this.cache[name])
          : await this.api.countActivePasses(this.venues[i]).then(num => {
              this.cache[name] = num;
              this.venues[i].passes = num;
            });
      }
    });
  }
  public initVenue = (): Venue => this.api.getNewVenue(this.current);

  // public sort() {
  //   return this.cities.sort((a, b) => {
  //     var statusA = this.status(a);
  //     var statusB = this.status(b);
  //     if (statusA == "GOOD" && statusB != "GOOD") return -1;
  //     if (statusA != "GOOD" && statusB == "GOOD") return 1;
  //     if (statusA == "ERROR" && statusB != "ERROR") return -1;
  //     if (statusA != "ERROR" && statusB == "ERROR") return 1;
  //     return a > b ? 1 : a < b ? -1 : 0;
  //   });
  // }

  initObserver = () => (this.cities$ = this.api.getAll());

  initSubscription() {
    if (this.cSubscription != null) this.cSubscription.unsubscribe();
    this.cSubscription = this.cities$.subscribe(async cities => {
      this.placeholders = cities.length;
      this.cities = await this.countActiveVenues(cities);
      // this.sort();
    });
  }

  status(city: City) {
    if (city.is_active && city.active_venues > 0) return "GOOD";
    if (
      (city.is_active && city.active_venues == 0) ||
      (!city.is_active && city.active_venues > 0)
    )
      return "ERROR";
    return "HIDDEN";
  }

  async countActiveVenues(cities: City[]): Promise<City[]> {
    this.total_active_venues = 0;
    for (var i = 0; i < cities.length; i++) {
      cities[i].active_venues = await this.api.countActiveVenues(cities[i]);
      this.total_active_venues += cities[i].active_venues;
    }
    return cities;
  }

  async countActivePasses(): Promise<void> {
    for (var i = 0; i < this.current.venues.length; i++)
      this.current.venues[i].passes = await this.api.countActivePasses(
        this.current.venues[i]
      );
    return;
  }

  rerank(begin: number, end: number) {
    for (var i = begin; i <= end; i++) {
      this.api.updateVenueRank(this.current, this.venues[i].id, i);
    }
  }

  getGeopoint = (
    city_name: string,
    state: string
  ): Promise<firebase.firestore.GeoPoint> =>
    this.api.getGeopoint(city_name, state);

  getTimezone = (pt: firebase.firestore.GeoPoint): Promise<string> =>
    this.api.getTimezone(pt);

  addVenue = (venue: Venue) => this.api.addVenue(this.current, venue);
}
